// extracted by mini-css-extract-plugin
module.exports = {"list":"CardIcons_list_16GEG","card":"CardIcons_card_3ih0-","icon":"CardIcons_icon_1xivv"};